import { Citation } from "../types";

const CITATION_FENCE = "```citations";

// Some backend chat sessions include the chat title in the LLM system prompt,
// which causes the model to start its reply with a "Title: ..." line.
// Strip those leading lines so they never reach the user.
const stripLeadingTitle = (text: string): string =>
  text.replace(/^\s*(?:#+\s*)?(?:title|chat title|session title)\s*:\s*[^\n]*\n+/i, "").trimStart();

export function parseCitations(content: string): { visible: string; citations: Citation[] } {
  const fenceStart = content.indexOf(CITATION_FENCE);
  if (fenceStart === -1) {
    return { visible: stripLeadingTitle(content), citations: [] };
  }

  const visible = stripLeadingTitle(content.slice(0, fenceStart).trimEnd());
  const after = content.slice(fenceStart + CITATION_FENCE.length);
  const fenceEnd = after.indexOf("```");
  if (fenceEnd === -1) {
    return { visible, citations: [] };
  }

  const json = after.slice(0, fenceEnd).trim();
  try {
    const parsed = JSON.parse(json);
    if (!Array.isArray(parsed)) {
      return { visible, citations: [] };
    }
    const citations = parsed.filter(
      (c: any): c is Citation =>
        c &&
        typeof c.id === "number" &&
        typeof c.tid === "string" &&
        typeof c.page === "number" &&
        typeof c.excerpt === "string"
    );
    return { visible, citations };
  } catch {
    return { visible, citations: [] };
  }
}
